import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M22 21C22 20.4477 21.5523 20 21 20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21ZM16 4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V16C8 17.1046 8.89543 18 10 18H14C15.1046 18 16 17.1046 16 16V4Z" />,
  'LayerAlignBottomCenter'
);
